import { Fragment } from 'react';
import { Kbd } from './Kbd';
import styles from './KeyHint.module.css';

export type KeyHintPart = string | { key: string };

/** The line in a screen's corner that says which keys do what: "Press [A] to [H] or click". */
export function KeyHint({ parts }: { parts: readonly KeyHintPart[] }) {
  return (
    <p className={styles.hint}>
      {parts.map((part, i) => (
        <Fragment key={i}>{typeof part === 'string' ? <span>{part}</span> : <Kbd size="sm">{part.key}</Kbd>}</Fragment>
      ))}
    </p>
  );
}
